import { PrimeIcons } from 'primereact/api';
import React from 'react';
import { ButtonClose, ButtonDelete } from '../../../components/Buttons';
import { ModalDialog } from '../../../components/ModalDialog';

export const ConfirmDeleteBodyDialog = ({ isVisible, onHide, handleDeleteBody, body }) => {
    return (
        <ModalDialog
            visible={isVisible}
            header={'Potvrďte smazání'}
            style={{ width: 450 }}
            footer={
                <>
                    <ButtonClose label='Ne' onClick={onHide} />
                    <ButtonDelete label='Ano' onClick={handleDeleteBody} />
                </>
            }
            onHide={onHide}
        >
            {body && (
                <div className='dialog-text'>
                    <span className='dialog-text__warning'>
                        <i className={PrimeIcons.EXCLAMATION_TRIANGLE} />
                        <span>
                            Opravdu chcete smazat orgán <b>{body.name}</b>?
                        </span>
                    </span>
                    <span>Tato akce je nevratná!</span>
                </div>
            )}
        </ModalDialog>
    );
};
